import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import( './views/Home.vue')
    },
    {
      path: '/coffee',
      name: 'coffee',
      component: () => import( './views/Coffee.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import( './views/Contact.vue')
    },
    {
      path: '/careers',
      name: 'careers',
      component: () => import( './views/Careers.vue')
    },
    {
      path: '/careers/:id',
      name: 'careers',
      component: () => import( './views/Careers.vue')
    },
    {
      path: '/services',
      name: 'services',
      component: () => import( './views/Services.vue')
    },
    {
      path: '/team',
      name: 'team',
      component: () => import( './views/Team.vue')
    },
    {
      path: '/ibbs',
      name: 'ibbs',
      component: () => import( './views/IBBS.vue')
    },
    {
      path: '*',
      name: '404',
      component: () => import( './views/Home.vue'),
      props: { notfound: true }
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

})
